exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lista-efeitos-colaterais li[data-v-ae51f5e8]:before{content:\"=> \";font-weight:700}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/grvs/components/ExcluirGrvAlerta.vue"],"names":[],"mappings":"AACA,qDACE,cAAe,AACf,eAAkB,CACnB","file":"ExcluirGrvAlerta.vue","sourcesContent":["\n.lista-efeitos-colaterais li[data-v-ae51f5e8]::before {\n  content: '=> ';\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ae51f5e8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/website/grvs/components/ExcluirGrvAlerta.vue
// module id = 1978
// module chunks = 1